import { createContext, useContext, ReactNode } from 'react';

export interface IFormContainerContext {
  isFormLoading: boolean;
  isFormSubmitted: boolean;
}

const FormContainerContext = createContext<IFormContainerContext>(
  {} as IFormContainerContext,
);
export const useFormContainerContext = () => useContext(FormContainerContext);

export const FormContainerProvider = ({
  children,
  params,
}: {
  children: ReactNode;
  params: IFormContainerContext;
}) => {
  return (
    <FormContainerContext.Provider value={{ ...params }}>
      {children}
    </FormContainerContext.Provider>
  );
};
